// extracted by mini-css-extract-plugin
export default {"wrap":"nG-z","fullWidth":"oG-z","hideOnDesktop":"pG-z","content":"qG-z","hasOpenedNav":"rG-z","crumbsList":"sG-z","dropdownsWrap":"tG-z"};